import { render, staticRenderFns } from "./TextFrame.vue?vue&type=template&id=0c2697a3&scoped=true&lang=pug&"
import script from "./TextFrame.vue?vue&type=script&lang=ts&"
export * from "./TextFrame.vue?vue&type=script&lang=ts&"
import style0 from "./TextFrame.vue?vue&type=style&index=0&id=0c2697a3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2697a3",
  null
  
)

export default component.exports